import base from "./base.service"
const addfolder = payload => base.post('/folders/add', payload)
const folderlist = payload => base.get(`/folders/list?skip=${payload?.skip}&limit=${payload?.limit}`)
const editfolder = payload => base.put('/folders/update', payload)
const deletefolder = folderId => base.get(`/folders/delete?folderId=${folderId}`)
const foldereditlist = folderId => base.get(`/folders/folder/${folderId}`)
const attachfolder = payload => base.post(`/folders/attachFolderToJob`, payload)
const pilotClientList = payload => base.get('/folders/pilotClients', payload)
const shareList = payload => base.post('/folders/share', payload)
const editFile = payload => base.post(`/folders/attachFolderToJob`, payload)
const verifyPassword = payload => base.post('/folders/verifyPassword', payload)

export const folderService = {
    addfolder,
    folderlist,
    editfolder,
    deletefolder,
    foldereditlist,
    attachfolder,
    pilotClientList,
    shareList,
    editFile,
    verifyPassword

}